import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../utils/Utils";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";

class QuadroClinicoEsordio extends Component {
    state={
        quadroClinicoEsordio:{
            dataSintomi: "",
            presenzaSintomi:"",
            ittero:"",
            diarrea: "",
            febbre: "",
            urine: "",
            doloreAddominale: "",
            feci: "",
            perdita: "",
            testa:"",
            nausea: "",
            doloriArticolari:"",
            vomito: "",
            astenia: "",
            altriSintomi: "",
            quadroNeurologico:"",
            paralisi:"",
            amiotrofia: "",
            mielite: "",
            meningo: "",
            sindrome: "",
            altro: "",
            ricovero: "",
            durata: "",
            corretto:[]

        },
        propsDataNascita:"",
        propsDataIntervista:"",
        propsAnnoTrapianto:"",
        propsDataInizio:"",
        propsDataDecesso:""

    }

    constructor(props) {
        super(props);
        this.riceviValoreInput=this.riceviValoreInput.bind(this);
        this.pulisciValori=this.pulisciValori.bind(this);
        this.validate=this.validate.bind(this);
    }

    componentDidMount() {

        let newState=this.state.quadroClinicoEsordio;
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.quadroClinicoEsordio){
            let quadroClinicoEsordioCopia=this.props.segnalazioneCopia.schedaSpeciale.quadroClinicoEsordio;
            newState.dataSintomi=quadroClinicoEsordioCopia.dataSintomi ? quadroClinicoEsordioCopia.dataSintomi : "";
            newState.presenzaSintomi=quadroClinicoEsordioCopia.presenzaSintomi ? quadroClinicoEsordioCopia.presenzaSintomi : "";
            newState.ittero=quadroClinicoEsordioCopia.ittero ? quadroClinicoEsordioCopia.ittero : "";
            newState.diarrea=quadroClinicoEsordioCopia.diarrea ? quadroClinicoEsordioCopia.diarrea : "";
            newState.febbre=quadroClinicoEsordioCopia.febbre ? quadroClinicoEsordioCopia.febbre : "";
            newState.urine=quadroClinicoEsordioCopia.urine ? quadroClinicoEsordioCopia.urine : "";
            newState.doloreAddominale=quadroClinicoEsordioCopia.doloreAddominale ? quadroClinicoEsordioCopia.doloreAddominale : "";
            newState.feci=quadroClinicoEsordioCopia.feci ? quadroClinicoEsordioCopia.feci : "";
            newState.perdita=quadroClinicoEsordioCopia.perdita ? quadroClinicoEsordioCopia.perdita : "";
            newState.testa=quadroClinicoEsordioCopia.testa ? quadroClinicoEsordioCopia.testa : "";
            newState.nausea=quadroClinicoEsordioCopia.nausea ? quadroClinicoEsordioCopia.nausea : "";
            newState.doloriArticolari=quadroClinicoEsordioCopia.doloriArticolari ? quadroClinicoEsordioCopia.doloriArticolari : "";
            newState.vomito=quadroClinicoEsordioCopia.vomito ? quadroClinicoEsordioCopia.vomito : "";
            newState.astenia=quadroClinicoEsordioCopia.astenia ? quadroClinicoEsordioCopia.astenia : "";
            newState.altriSintomi=quadroClinicoEsordioCopia.altriSintomi ? quadroClinicoEsordioCopia.altriSintomi : "";
            newState.quadroNeurologico=quadroClinicoEsordioCopia.quadroNeurologico ? quadroClinicoEsordioCopia.quadroNeurologico : "";
            newState.paralisi=quadroClinicoEsordioCopia.paralisi ? quadroClinicoEsordioCopia.paralisi : "";
            newState.amiotrofia=quadroClinicoEsordioCopia.amiotrofia ? quadroClinicoEsordioCopia.amiotrofia : "";
            newState.mielite=quadroClinicoEsordioCopia.mielite ? quadroClinicoEsordioCopia.mielite : "";
            newState.meningo=quadroClinicoEsordioCopia.meningo ? quadroClinicoEsordioCopia.meningo : "";
            newState.sindrome=quadroClinicoEsordioCopia.sindrome ? quadroClinicoEsordioCopia.sindrome : "";
            newState.altro=quadroClinicoEsordioCopia.altro ? quadroClinicoEsordioCopia.altro : "";
            newState.ricovero=quadroClinicoEsordioCopia.ricovero ? quadroClinicoEsordioCopia.ricovero : "";
            newState.durata=quadroClinicoEsordioCopia.durata ? quadroClinicoEsordioCopia.durata : "";
        } else {
            newState.dataSintomi=this.props.segnalazioneCopia.datiSanitari.dataInizioSintomi ? Utils.transformDateForFrontend(this.props.segnalazioneCopia.datiSanitari.dataInizioSintomi) : "";
        }
        let newPropsDataIntervista=this.props.informazioniSulCaso.dataIntervista ? this.props.informazioniSulCaso.dataIntervista : "";
        let newPropsDataNascita=this.props.informazioniSulCaso.dataNascita ? this.props.informazioniSulCaso.dataNascita : "";
        let newPropsAnnoTrapianto=this.props.annoTrapianto ? this.props.annoTrapianto : "";
        let newPropsDataInizio=this.props.dataInizio ? this.props.dataInizio : "";
        let newPropsDataDecesso=this.props.dataDecesso ? this.props.dataDecesso : "";
        this.setState({quadroClinicoEsordio: newState, propsDataNascita:newPropsDataNascita, propsDataIntervista:newPropsDataIntervista, propsAnnoTrapianto:newPropsAnnoTrapianto, propsDataInizio:newPropsDataInizio, propsDataDecesso:newPropsDataDecesso});
        this.controlloDati();
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.quadroClinicoEsordio}, "corretto"))
        this.props.setStatePadre(newState, "quadroClinicoEsordio", objectForBackend, this.validate())
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        
        if ((prevProps.informazioniSulCaso !== this.props.informazioniSulCaso) || (prevProps.annoTrapianto !== this.props.annoTrapianto) || (prevProps.dataInizio !== this.props.dataInizio) || (prevProps.dataDecesso !== this.props.dataDecesso)) {
            if (this.state.propsDataNascita !== this.props.informazioniSulCaso.dataNascita || this.state.propsDataIntervista !== this.props.informazioniSulCaso.dataIntervista || this.state.propsAnnoTrapianto !== this.props.annoTrapianto || this.state.propsDataInizio !== this.props.dataInizio) {
                let newState = this.state.quadroClinicoEsordio;
                let newStatePulito = this.pulisciValori(newState);
                let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.quadroClinicoEsordio}, "corretto"))
                this.props.setStatePadre(newStatePulito, "quadroClinicoEsordio", objectForBackend, this.validate());
            }
        }
    }


    riceviValoreInput(field, event){
        let newState= this.state.quadroClinicoEsordio;
        if (field && field.target && field.target.id){
            newState[field.target.id]=field.target.value;
        }
        else {
            newState[field]=event.target.value;
        }
        let newStatePulito =this.pulisciValori(newState)
        this.setState({quadroClinicoEsordio: newStatePulito})
        this.controlloDati();
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.quadroClinicoEsordio}, "corretto"))
        this.props.setStatePadre(newStatePulito, "quadroClinicoEsordio", objectForBackend, this.validate())
    }

    validate() {
        if (this.state.quadroClinicoEsordio.dataSintomi && this.props.informazioniSulCaso.dataNascita && this.props.informazioniSulCaso.dataIntervista) {
            let validatedataSintomi = Utils.checkDateInterval(this.state.quadroClinicoEsordio.dataSintomi, "31/12/1899");
            let validatedataSintomiOdierna = Utils.checkDateInterval(this.state.quadroClinicoEsordio.dataSintomi, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));
            let confrontoSintomiIntervista= Utils.checkDateInterval(this.state.quadroClinicoEsordio.dataSintomi, this.props.informazioniSulCaso.dataIntervista);
            let confrontoSintomiNascita= Utils.checkDateInterval(this.state.quadroClinicoEsordio.dataSintomi, this.props.informazioniSulCaso.dataNascita);

            if (validatedataSintomi) {
                return "Messages.DataSintomi"
            } else if (!validatedataSintomiOdierna) {
                return "Messages.DataSintomiOdierna"
            }
            if (!confrontoSintomiIntervista) {
                return "Messages.ERR_01_02_0I_AS"
            }
            if (confrontoSintomiNascita){
                return "Messages.ERR_01_02_0I_AT"
            }
        }
        if (this.state.quadroClinicoEsordio.dataSintomi && this.props.annoTrapianto){
            let annoSintomi=this.state.quadroClinicoEsordio.dataSintomi.substring(6,10);
            if (annoSintomi<this.props.annoTrapianto){
                return "Messages.ERR_01_02_0I_AZ"
            }
        }
        if (this.state.quadroClinicoEsordio.dataSintomi && this.props.dataInizio) {
            let confrontoSintomiInizio = Utils.checkDateInterval(this.state.quadroClinicoEsordio.dataSintomi, this.props.dataInizio);
            if (confrontoSintomiInizio) {
                return "Messages.ERR_01_02_0I_AV"
            }
        }
            if (this.state.quadroClinicoEsordio.dataSintomi && this.props.dataDecesso) {
                let confrontoSintomiDecesso = Utils.checkDateInterval(this.state.quadroClinicoEsordio.dataSintomi, this.props.dataDecesso);
                if (!confrontoSintomiDecesso) {
                    return "Messages.ERR_01_02_0I_BA"
                }
            }
        return ""
    }

    pulisciValori(state){
        let newState = state
        if(newState.presenzaSintomi !== "01"){
            newState.ittero= "";
            newState.diarrea= "";
            newState.febbre= "";
            newState.urine= "";
            newState.doloreAddominale= "";
            newState.feci= "";
            newState.perdita= "";
            newState.testa= "";
            newState.nausea= "";
            newState.doloriArticolari= "";
            newState.vomito= "";
            newState.astenia= "";
            newState.altriSintomi= "";
        }
        if (newState.quadroNeurologico!=="01"){
            newState.paralisi= "";
            newState.amiotrofia= "";
            newState.mielite= "";
            newState.meningo= "";
            newState.sindrome= "";
            newState.altro= "";
        }
        if (newState.ricovero!=="01"){
            newState.durata="";
        }

        return newState
    }

    controlloDati(){
        let quadroClinicoEsordio=this.state.quadroClinicoEsordio;
        quadroClinicoEsordio.corretto=[];

        if (!quadroClinicoEsordio.presenzaSintomi)quadroClinicoEsordio.corretto[0]="Campo \"Presenza di sintomi\" mancante";
        if (!quadroClinicoEsordio.dataSintomi ||
            (quadroClinicoEsordio.dataSintomi && (Utils.isDateInValid(Utils.transformDateForBackend(quadroClinicoEsordio.dataSintomi), "-"))))quadroClinicoEsordio.corretto[1]="Campo \"Data di inizio sintomi\" mancante o errato";
        if (!quadroClinicoEsordio.quadroNeurologico)quadroClinicoEsordio.corretto[2]="Campo \"Quadro clinico neurologico\" mancante";

        this.setState({quadroClinicoEsordio: quadroClinicoEsordio});

    }

    render(){
        const {t}=this.props
        return(
            <div>
                <div style={{marginTop: "10px"}}/>
                <div><h6>Quadro clinico di esordio</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div className={"row"}>
                            <div className={"col-lg-12 mt-1"}>
                                <div className={"row"}>
                                    <div className={"col-lg-7"}>
                                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.presenzaSintomi")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <div className={"row"}>
                                            <div className={"col-lg-1"}>
                                                <RadioButton id={"sintomiSi"}
                                                             name={"presenzaSintomi"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                             value={"01"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.quadroClinicoEsordio.presenzaSintomi === "01"}
                                                />
                                            </div>
                                            <div className={"col-lg-1"}>
                                                <RadioButton id={"sintomiNo"}
                                                             name={"presenzaSintomi"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                             value={"02"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.quadroClinicoEsordio.presenzaSintomi === "02"}
                                                />
                                            </div>
                                            <div className={"col-lg-2"}>
                                                <RadioButton id={"sintomiNonSo"}
                                                             name={"presenzaSintomi"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                             value={"03"}
                                                             newRadio={true}
                                                             onClick={this.riceviValoreInput}
                                                             checked={this.state.quadroClinicoEsordio.presenzaSintomi === "03"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9",marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.dataInizioSintomi")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <Calendar
                                            id={"dataSintomi"}
                                            field={"dataSintomi"}
                                            value={this.state.quadroClinicoEsordio.dataSintomi}
                                            onChange={this.riceviValoreInput}
                                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                             "Data")}
                                            error={(this.state.quadroClinicoEsordio.dataSintomi === "" ||
                                             this.state.quadroClinicoEsordio.dataSintomi == null) ? false :
                                             Utils.isDateInValid(Utils.transformDateForBackend(this.state.quadroClinicoEsordio.dataSintomi), "-")}
                                        >
                                        </Calendar>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <fieldset disabled={this.state.quadroClinicoEsordio.presenzaSintomi !== "01"}>
                            <div className={"row"}>
                                <div className={"col-lg-4"}>
                                    <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "2rem"}}>
                                        {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.seSi")}
                                    </p>
                                </div>
                            </div>
                            <div style={{marginLeft:"2rem"}}>
                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.ittero")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"itteroSi"}
                                                     name={"ittero"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.ittero === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"itteroNo"}
                                                     name={"ittero"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.ittero === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"itteroNonSo"}
                                                     name={"ittero"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.ittero === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.diarrea")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"diarreaSi"}
                                                     name={"diarrea"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.diarrea === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"diarreaNo"}
                                                     name={"diarrea"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.diarrea === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"diarreaNonSo"}
                                                     name={"diarrea"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.diarrea === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.febbre")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"febbreSi"}
                                                     name={"febbre"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.febbre === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"febbreNo"}
                                                     name={"febbre"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.febbre === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"febbreNonSo"}
                                                     name={"febbre"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.febbre === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.urine")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"urineSi"}
                                                     name={"urine"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.urine === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"urineNo"}
                                                     name={"urine"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.urine === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"urineNonSo"}
                                                     name={"urine"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.urine === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.doloreAddominale")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"doloreAddominaleSi"}
                                                     name={"doloreAddominale"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.doloreAddominale === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"doloreAddominaleNo"}
                                                     name={"doloreAddominale"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.doloreAddominale === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"doloreAddominaleNonSo"}
                                                     name={"doloreAddominale"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.doloreAddominale === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.feci")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"feciSi"}
                                                     name={"feci"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.feci === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"feciNo"}
                                                     name={"feci"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.feci === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"feciNonSo"}
                                                     name={"feci"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.feci === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.perdita")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"perditaSi"}
                                                     name={"perdita"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.perdita === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"perditaNo"}
                                                     name={"perdita"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.perdita === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"perditaNonSo"}
                                                     name={"perdita"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.perdita === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.testa")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"testaSi"}
                                                     name={"testa"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.testa === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"testaNo"}
                                                     name={"testa"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.testa === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"testaNonSo"}
                                                     name={"testa"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.testa === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nausea")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"nauseaSi"}
                                                     name={"nausea"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.nausea=== "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"nauseaNo"}
                                                     name={"nausea"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.nausea === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"nauseaNonSo"}
                                                     name={"nausea"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.nausea === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.doloriArticolari")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"doloriArticolariSi"}
                                                     name={"doloriArticolari"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.doloriArticolari === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"doloriArticolariNo"}
                                                     name={"doloriArticolari"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.doloriArticolari === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"doloriArticolariNonSo"}
                                                     name={"doloriArticolari"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.doloriArticolari === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.vomito")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"vomitoSi"}
                                                     name={"vomito"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.vomito === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"vomitoNo"}
                                                     name={"vomito"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.vomito === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"vomitoNonSo"}
                                                     name={"vomito"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.vomito === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.astenia")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"asteniaSi"}
                                                     name={"astenia"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.astenia === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"asteniaNo"}
                                                     name={"astenia"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.astenia === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"asteniaNonSo"}
                                                     name={"astenia"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.astenia === "03"}
                                        />
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.altriSintomi")}
                                        </p>
                                    </div>
                                    <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello2' : ''}`}>
                                        <Input
                                            type={"textarea"}
                                            id={"altriSintomi"}
                                            onChange={this.riceviValoreInput}
                                            field={"altriSintomi"}
                                            value={this.state.quadroClinicoEsordio.altriSintomi}
                                            placeholder={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.altriSintomi")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <div className={"row"}>
                            <div className={"col-lg-8"}>
                                <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.quadroNeurologico")}
                                    <span className={styles.mandatoryColor}>*</span>
                                </p>
                                <div className={"row"}>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"quadroNeurologicoSi"}
                                                     name={"quadroNeurologico"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.quadroNeurologico === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"quadroNeurologicoNo"}
                                                     name={"quadroNeurologico"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.quadroNeurologico === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"quadroNeurologicoNonSo"}
                                                     name={"quadroNeurologico"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.quadroNeurologico === "03"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <fieldset disabled={this.state.quadroClinicoEsordio.quadroNeurologico !== "01"}>
                            <div className={"row"}>
                                <div className={"col-lg-4"}>
                                    <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "2rem"}}>
                                        {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.seSi")}
                                    </p>
                                </div>
                            </div>
                            <div style={{marginLeft:"2rem"}}>
                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.paralisi")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"paralisiSi"}
                                                     name={"paralisi"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.paralisi === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"paralisiNo"}
                                                     name={"paralisi"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.paralisi === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"paralisiNonSo"}
                                                     name={"paralisi"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.paralisi === "03"}
                                        />
                                    </div>
                                </div>


                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.amiotrofia")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"amiotrofiaSi"}
                                                     name={"amiotrofia"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.amiotrofia === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"amiotrofiaNo"}
                                                     name={"amiotrofia"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.amiotrofia === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"amiotrofiaNonSo"}
                                                     name={"amiotrofia"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.amiotrofia === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.mielite")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"mieliteSi"}
                                                     name={"mielite"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.mielite === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"mieliteNo"}
                                                     name={"mielite"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.mielite === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"mieliteNonSo"}
                                                     name={"mielite"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.mielite === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.meningo")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"meningoSi"}
                                                     name={"meningo"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.meningo === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"meningoNo"}
                                                     name={"meningo"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.meningo=== "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"meningoNonSo"}
                                                     name={"meningo"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.meningo === "03"}
                                        />
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.sindrome")}
                                        </p>
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"sindromeSi"}
                                                     name={"sindrome"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.sindrome === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"sindromeNo"}
                                                     name={"sindrome"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.sindrome === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"sindromeNonSo"}
                                                     name={"sindrome"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.sindrome === "03"}
                                        />
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.altro")}
                                        </p>
                                    </div>
                                    <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <Input
                                            type={"textarea"}
                                            id={"altro"}
                                            onChange={this.riceviValoreInput}
                                            field={"altro"}
                                            value={this.state.quadroClinicoEsordio.altro}
                                            placeholder={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.altro")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <div className={"row"}>
                            <div className={"col-lg-7"}>
                                <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.ricovero")}
                                </p>
                                <div className={"row"}>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"ricoveroSi"}
                                                     name={"ricovero"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.si")}
                                                     value={"01"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.ricovero === "01"}
                                        />
                                    </div>
                                    <div className={"col-lg-1"}>
                                        <RadioButton id={"ricoveroNo"}
                                                     name={"ricovero"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.no")}
                                                     value={"02"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.ricovero === "02"}
                                        />
                                    </div>
                                    <div className={"col-lg-2"}>
                                        <RadioButton id={"ricoveroNonSo"}
                                                     name={"ricovero"} label={t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.nonSo")}
                                                     value={"03"}
                                                     newRadio={true}
                                                     onClick={this.riceviValoreInput}
                                                     checked={this.state.quadroClinicoEsordio.ricovero === "03"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                <p className={styles.labelHeader} style={{color: "#1b7ea9",marginTop: "10px"}}>
                                    {t("SchedaSpecialeEpatiteE.QuadroClinicoEsordio.durata")}
                                </p>
                                <Input
                                    type={"textarea"}
                                    id={"durata"}
                                    onChange={this.riceviValoreInput}
                                    field={"durata"}
                                    disabled={!this.state.quadroClinicoEsordio.ricovero || this.state.quadroClinicoEsordio.ricovero !== "01"}
                                    value={this.state.quadroClinicoEsordio.durata}
                                    placeholder={"Giorni di degenza"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
}
export default withTranslation('common')(QuadroClinicoEsordio)
